/* upload.icon.svg.js */

module.exports = {
    icon: `<svg viewBox="2 2 20 20" preserveAspectRatio="none">
        <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"></path>
    </svg>`,
};
